var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-access"},[_c('h2',[_vm._v(_vm._s(_vm.$t("global.no_access")))]),_c('p',[_vm._v(_vm._s(_vm.$t("global.you_don_t_have_access_to_the_back_office")))])])}
var staticRenderFns = []

export { render, staticRenderFns }